import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { PageLoader } from '../shared/pageLoader/PageLoader';
// import ForgotPassword from '../components/forgotPassword/ForgotPassword'

function UnAuthenticatedRoutes() {
    const Login = React.lazy(() => import('../components/login/Login'))
    const ForgotPassword = React.lazy(() => import('../components/forgotPassword/ForgotPassword'))
    const PageNotFound = React.lazy(() => import('../shared/pageNotFound/PageNotFound'))


    return (
        <Suspense fallback={<PageLoader />}>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/forgotPassword" element={<ForgotPassword />} />
                <Route path="*" element={<PageNotFound />} />
            </Routes>
        </Suspense>
    );
}

export default UnAuthenticatedRoutes;